import React, { useState } from 'react'
import { CustomInputChangeEvent } from '../../../../utils/models/events/CustomInputChangeEvent'
import { InvoiceAddressEditor, InvoiceAddressEditorViewModel, InvoiceAddressForm } from './invoice-address-editor.component'

interface WrapperProps {
  initialForm: InvoiceAddressForm
  onFormChange: (form: InvoiceAddressForm) => void
  disabled: boolean
  initialState: boolean
}

export function InvoiceAddressEditorWrapper({ disabled, onFormChange, initialState, initialForm: initialForm }: WrapperProps) { 
  const vm = useViewModel(initialForm, onFormChange, disabled, initialState)
  return <InvoiceAddressEditor {...vm} />;
}

function useViewModel(
  initialForm: InvoiceAddressForm,
  onFormChange: (form: InvoiceAddressForm) => void,
  disabled: boolean,
  initialState: boolean): InvoiceAddressEditorViewModel {

  const [toggleState, setToggleState] = useState(initialState);

  const form = {
    ...initialForm
  }

  function handleFormChange(event: React.ChangeEvent<HTMLInputElement> | CustomInputChangeEvent) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    //@ts-ignore
    form[name] = value;

    onFormChange(form);
  }

  const toggle = () => { setToggleState(!toggleState) }

  return {
    disabled,
    form,
    onFormChange: handleFormChange,
    initialState: toggleState,
    onToggle: toggle
  };
}
